import React from "react"
import { Table } from "react-bootstrap"
import styled from 'styled-components'

import SaleContext from "../../context"
import { formatCurrencyValue } from "../../../../../utils"
import ScrollBox from "../../../../../_components/ScrollBox"

const BoxWithOutItems = styled.div`
display: flex;
flex-direcation: column;
alig-items: flex-end;
justify-content: center;
height: ${window.screen.height * .4}px;
`
const BoxWithOutItemsIcon = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
font-size: 3em;
color: #ebebeb;
`

export default props => <SaleContext.Consumer>
    {
        sale => <ScrollBox>
            {
                sale.items.length
                    ? <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>Remover</th>
                                <th>Item</th>
                                <th>Cód.</th>
                                <th>Cód. Barras</th>
                                <th>Quantidade</th>
                                <th>Valor</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                sale.items.map((item, index) => {
                                    item["index"] = index
                                    item.product = item.id

                                    if (item.sellable.name && item.sellable.name.length > 30) {
                                        item.sellable.name = `${item.sellable.name.substring(0, 30)}...`
                                    }

                                    const unitPrice = item.item_sale_price != null
                                        ? item.item_sale_price
                                        : item.sellable.price;

                                    const price = formatCurrencyValue(unitPrice);
                                    const total = formatCurrencyValue(unitPrice * item.quantity);

                                    const key = `pos-sale-item-id-${item.id}-index-${index}`
                                    return <tr key={key}>
                                        <td title="Remover item">
                                            <i
                                                id={item.id}
                                                onClick={props.onRemoveItem}
                                                style={{ cursor: "pointer" }}
                                                className="fas fa-trash text-danger ml-2"
                                            ></i>
                                        </td>
                                        <td>
                                            {
                                                item.sellable.name
                                            }
                                        </td>
                                        <td>
                                            <strong>{item.sellable.code}</strong>
                                        </td>
                                        <td>
                                            <strong>{item.sellable.barcode || "-"}</strong>
                                        </td>
                                        <td>
                                            <strong> {item.quantity} </strong>{" "}
                                            <i
                                                onClick={() => props.openModalDiscount(item)}
                                                title="Atualizar a quantidade"
                                                style={{ cursor: "pointer" }}
                                                className="fas fa-edit ml-2"
                                            ></i>
                                        </td>
                                        <td>
                                            {price}
                                            <i
                                                onClick={() => props.openModalPrice(item)}
                                                title="Alterar preço"
                                                style={{ cursor: "pointer" }}
                                                className="fas fa-edit ml-2"
                                            ></i>
                                        </td>
                                        <td>
                                            {total}
                                        </td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </Table>

                    : <BoxWithOutItems>
                        <BoxWithOutItemsIcon>
                            <i className="fas fa-box-open "></i>
                        </BoxWithOutItemsIcon>
                    </BoxWithOutItems>

            }
        </ScrollBox>
    }
</SaleContext.Consumer>




// WEBPACK FOOTER //
// ./src/views/AppViews/POS/components/TableItems/index.jsx